<template>
  <div>
    <h5 class="text-sm font-medium text-gray-600 leading-4 mb-4">Assigned To</h5>
    <AssignForm v-if="!loading" :contact-request="contactRequest" />
  </div>
</template>

<script>
import AssignForm from './assignManager/AssignForm.vue';

export default {
  components: {
    AssignForm,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters['ui/contactRequestUser/itemByParent'](this.contactRequest.id);
    },
  },
  created() {
    this.fetchUser();
  },
  methods: {
    async fetchUser() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/contactRequestUser/read', {
          id: this.contactRequest.id,
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
